import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService, UserProfile } from '../services/auth.service';

export function roleGuard(...roles: UserProfile['role'][]): CanActivateFn {
  return () => {
    const auth = inject(AuthService);
    const router = inject(Router);
    const role = auth.role();

    if (role && roles.includes(role)) return true;
    if (role === 'owner') return router.createUrlTree(['/portal/dashboard']);
    if (!role) return router.createUrlTree(['/login']);
    return router.createUrlTree(['/dashboard']);
  };
}
